import { render, staticRenderFns } from "./userScreen.vue?vue&type=template&id=5cd3d394&scoped=true&"
import script from "./userScreen.vue?vue&type=script&lang=js&"
export * from "./userScreen.vue?vue&type=script&lang=js&"
import style0 from "./userScreen.vue?vue&type=style&index=0&id=5cd3d394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd3d394",
  null
  
)

export default component.exports